import { css } from "@emotion/core";
import * as React from "react";
import { Outlet } from "react-router-dom";
import { Card } from "@blueprintjs/core";

import { FybrLogo } from "../common";

// ... existing code ...

const Authenticate = () => {
  return (
    <div
      css={css`
        flex-grow: 1;
        display: flex;
        background: var(--background-gradient);
        justify-content: center;
        align-items: center;
      `}
    >
      <Card
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 4rem 3rem 2rem 3rem;
        `}
      >
        <header
          css={css`
            margin-bottom: 3rem;
          `}
        >
          <FybrLogo size={128} dark />
        </header>
        <main
          css={css`
            min-width: 360px;
          `}
        >
          <Outlet />
        </main>
      </Card>
    </div>
  );
};

export default Authenticate;
